module.exports = __webpack_public_path__ + "static/media/upload_file.514eaacf.svg";